import web from "../web";

class EtablissementsService {
    index(token){
        return web.get("/api/etablissements", { headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer '+token } })
    }
    store(data, token){
        //console.log(token)
        return web.post("api/etablissements", data,{ headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/etablissements/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/etablissements/update", data,{ headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/etablissements/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

}

export default new EtablissementsService()